import { useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import AdminDashboard from "./AdminDashboard";
import DriverDashboard from "./DriverDashboard";
import OwnerDashboard from "./OwnerDashboard";
import WelcomeDashboard from "./WelcomeDashboard";
import NotActiveAccount from "../no-auth/NotActiveAccount";

export default function DashboardLayout() {
    const { companySlug } = useParams();
    const { userProfile, company } = useAuth();

    // Super admin (notify company)
    if (companySlug === "notify") {
        return <OwnerDashboard />;
    }

    // Self-registered sandbox users see the welcome/onboarding dashboard
    if (company?.settings?.is_sandbox) {
        return <WelcomeDashboard />;
    }

    if (userProfile?.role === "driver") {
        return <DriverDashboard />;
    }

    // Default company dashboard
    return <AdminDashboard />;
}
